import React from "react";
import PredictionPage from "../../components/PredictionPage";

function Sugar() {
  return (
    <PredictionPage
      title="Sugar"
      content="This is the Sugar AI Trading Predictions page."
      canonical="/commodities/sugar-ai-trading-predictions"
      categoryKey="nav.commodities"
      categoryPath="/commodities"
      symbol="SUGAR"
    />
  );
}

export default Sugar;
